import { Button, ModalV3, useTranslation } from '@helios/frontend-core';

interface ExistingProjectModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  acquisitionChannel?: string;
}

const TRACKING_ID = 'existing-project-modal';

export const ExistingProjectModal = ({ isOpen, onDismiss, acquisitionChannel }: ExistingProjectModalProps) => {
  const { t } = useTranslation();

  const channelPrefix = `projectDetail.existingProjectModal.byAcquisitionChannel.${acquisitionChannel}`;
  const heading =
    t(`${channelPrefix}.heading`, { defaultValue: '' }) || t('projectDetail.existingProjectModal.heading');
  const body = t(`${channelPrefix}.body`, { defaultValue: '' }) || t('projectDetail.existingProjectModal.body');
  const ctaLabel = t(`${channelPrefix}.cta`, { defaultValue: '' }) || t('projectDetail.existingProjectModal.cta');

  const cta = (
    <div className="px-4">
      <Button onClick={onDismiss} trackingId={`${TRACKING_ID}-cta`}>
        {ctaLabel}
      </Button>
    </div>
  );

  return (
    <ModalV3
      open={isOpen}
      onClose={onDismiss}
      trackingId={TRACKING_ID}
      bottomSheetProps={{ showCloseButton: false }}
      cta={cta}
    >
      <div className="flex flex-col items-center gap-12 text-text-primary px-4">
        <h2 className="label-900 text-center">{heading}</h2>
        <p className="body-500">{body}</p>
      </div>
    </ModalV3>
  );
};
